import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { getLuckyNumActive } from "../../apis/services/steemActivity";
import VoteModel from "../../components/VoteModel.vue";
export default {
  components: {
    VoteModel: VoteModel
  },
  name: "page-visits-table",
  data: function data() {
    return {
      tableData: null,
      newActivity: null,
      showModel: false
    };
  },
  methods: {
    voteNewActivity: function voteNewActivity() {
      this.newActivity = this.tableData[0];
      this.showModel = true;
      this.$refs.voteModel.openModel();
    },
    closeModel: function closeModel() {
      this.showModel = false;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getLuckyNumActive();

            case 2:
              _this.tableData = _context.sent.data.items;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};